
import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class BlockDocument extends Vue {
  @Prop({ required: true }) readonly title!: string
  @Prop({ required: false }) state!: string
  @Prop({ required: true }) date!: string
}
